// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const i18nDateFormats: Record<string, (opts: any) => string | null> = {
    long: () => 'dd MMM yyyy',
    time: () => 'HH:mm:ss',
    timeShort: () => 'HH:mm',
    dayMonth: () => 'd MMM',
    dayMonthYearShort: () => 'dd MMM’yy',
    monthYear: () => 'MMMM yyyy',
    date: () => 'd',
    weekday: () => 'EEEE',
    weekdayShort: () => 'E',
    customDateFormat: (opts) => opts.format || null
};
